module.exports = __webpack_public_path__ + "static/blog05-f4ec3c0830c6dc488531f4e67371f2a0.png";